import { API_BASE_URL } from '../utils/apiConfig';

class LeaderboardService {
  // Get leaderboard rankings
  static async getLeaderboard(type = 'total', limit = 100, league = null) {
    try {
      const token = localStorage.getItem('moneysmart-token');
      if (!token) {
        throw new Error('Authentication required');
      }

      let url = `${API_BASE_URL}/leaderboard?type=${type}&limit=${limit}`;
      if (league && ['10k', '100k', '1M'].includes(league)) {
        url += `&league=${league}`;
      }

      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch leaderboard');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  // Get user's rank
  static async getMyRank(type = 'total', league = null) {
    try {
      const token = localStorage.getItem('moneysmart-token');
      if (!token) {
        throw new Error('Authentication required');
      }

      let url = `${API_BASE_URL}/leaderboard/my-rank?type=${type}`;
      if (league && ['10k', '100k', '1M'].includes(league)) {
        url += `&league=${league}`;
      }

      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch user rank');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default LeaderboardService;







